import React from 'react';
import {useStickyState} from "@lb/mlib-components";

const ZiggyContext = React.createContext({
    warehouse: '',
    search: '',
    updateWarehouse: () => {
    },
    playing: true,
    play: () => {
    },
    pause: () => {
    },
    load: false,
    callLoad: () => {
    },
});


export const ZiggyContextProvider = (props) => {

    const [warehouse, setWarehouse] = useStickyState("ABBOTSFORD", "ziggyWarehouseState");
    const [playing, setPlaying] = useStickyState(true, 'ziggyPlaying');

    const [search, setSearch] = useStickyState('', 'ziggySearch');

    const [load, setLoad] = React.useState(false);

    const updateSearchHandler = (title) => {
        setSearch(title);
    };

    const updateWarehouseHandler = (warehouse) => {
        setWarehouse(warehouse);
    };

    const playHandler = () => {
        setPlaying(true);
    };

    const pauseHandler = () => {
        setPlaying(false);
    };

    const callLoadHandler = React.useCallback(() => {
        setLoad((prev) => !prev);
    }, []);


    const contextValue = {
        warehouse: warehouse,
        search: search,
        updateSearch: updateSearchHandler,
        updateWarehouse: updateWarehouseHandler,
        playing: playing,
        play: playHandler,
        pause: pauseHandler,
        load: load,
        callLoad: callLoadHandler,
    };

    return (
        <ZiggyContext.Provider value={contextValue}>
            {props.children}
        </ZiggyContext.Provider>
    );
};

export default ZiggyContext;
